/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $File = {
  properties: {
    uri: {
      type: 'string',
      isRequired: true,
    },
    id: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    type: {
      type: 'string',
    },
    metadata: {
      type: 'dictionary',
      contains: {
        properties: {
        },
      },
    },
  },
} as const;
